import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TransactionsApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useDeleteTransaction = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => TransactionsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.TRANSACTIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ACCOUNTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CASHFLOWS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_HISTORY] });
    },
  });

  return {
    deleteTransaction: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    wasDeletedWithSuccess: mutation.isSuccess,
    wasDeletedWithoutSuccess: mutation.isError,
  };
};

export default useDeleteTransaction;
